define([
	"dojo/_base/declare",
	"csi/view/ToolbarPluginSwitchboard"
], function(declare,Switchboard) {

	return declare(Switchboard, {
		bDelayInitialization: true,
		idViewProperty: "activeMaterialType",
		resDefault: "SelectAll",
		switchboardPath: "Child:__Parent__/Child:ProductType/Child:ProductionConfig/Child:CompatibleTypes",

		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			// summary: do nothing - idViewProperty handles it all
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide if printing
			return !ctx.bPrint;
		}
	});
});